<template>
  <div>
    <half-page
      :visible.sync="visible"
      :title="downloadTitle"
      @onClose="onClose"
    >
      <div slot="body" class="half-page-download">
        <div class="half-page-download__guide">
          <introduction-chapter
            :imgConfigList="
              imgConfig[bankType] && imgConfig[bankType].openBankImgList
            "
            :showDetailSteps="false"
            :number="1"
            :rawHtmlText="rawHtmlTextOpen"
            :isFinished="hasOpenThatBank"
            :showFinsihedMark="false"
          />
          <div class="half-page-download__guide__icon">
            <div class="half-page-download__guide__icon--src"></div>
          </div>
          <introduction-chapter
            :imgConfigList="
              imgConfig[bankType] && imgConfig[bankType].bindWalletImgList
            "
            :showDetailSteps="false"
            :number="2"
            :rawHtmlText="rawHtmlTextBind"
            :isFinished="hasOpenThatBank"
            :showFinsihedMark="false"
          />
        </div>
        <div class="half-page-download__dcep">
          <div class="half-page-download__dcep__logo"></div>
          <div class="half-page-download__dcep__official">
            <div class="half-page-download__dcep__official--title">
              下载数字人民币APP
            </div>
            <div class="half-page-download__dcep__official--tip">
              <div class="official-icon"></div>
              <div class="official-text">中国人⺠银行官方发行App</div>
            </div>
          </div>
          <div class="half-page-download__dcep__button">
            <basic-button
              :buttonText="buttonText"
              width="1.8rem"
              height="0.61rem"
              :btnImg="btnImg"
              :bankType="bankType"
              :isFinished="hasOpenThatBank"
              :hasOpenThatBank="hasOpenThatBank"
              :pushSubWalletABStrategy="pushSubWalletABStrategy"
            />
            <div class="half-page-download__dcep__button--hand"></div>
          </div>
        </div>
        <div class="half-page-download__tip">
          为保证礼包成功发放，请使用 {{ mobileMask }} 登录
        </div>
      </div>
    </half-page>
  </div>
</template>
<script>
import { fetchGuideStepContent } from '@/common/horn';
import HalfPage from '../../components/HalfPage.vue';
import IntroductionChapter from '../../components/IntroductionChapter.vue';
import BasicButton from '../../components/BasicButton.vue';
export default {
  components: {
    HalfPage,
    IntroductionChapter,
    BasicButton
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    hasOpenThatBank: {
      type: Boolean,
      default: false
    },
    bankType: {
      type: String,
      default: ''
    },
    bankName: {
      type: String,
      default: ''
    },
    mobileMask: {
      type: String,
      default: ''
    },
    pushSubWalletABStrategy: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      downloadTitle: '仅差2步，30元礼包到账',
      buttonText: '下载领礼包',
      imgConfig: {},
      btnImg:
        'https://s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/half-page-download-btn-20220413.png'
    };
  },
  created() {
    this.getGuideStepContent();
  },
  computed: {
    rawHtmlTextBind() {
      return `选择美团，开通<span style="color: #1176D1">${this.bankName}</span>钱包快付`;
    },
    rawHtmlTextOpen() {
      return `下载数字人民币App开通<span style="color: #1176D1">${this.bankName}</span>钱包`;
    }
  },
  methods: {
    onClose() {
      this.$emit('update:visible', false);
      this.$emit('onClose');
    },
    getGuideStepContent() {
      fetchGuideStepContent()
        .then((res) => {
          if (!res) {
            throw new Error('res为空');
          }
          this.imgConfig = res.imgConfig || {};
        })
        .catch((error) => {
          console.log('horn error:', error);
        });
    }
  }
};
</script>
<style scoped lang="less">
@import '../../../../styles/fn.less';
.half-page-download {
  padding-top: 0.35rem;
  margin: 0 auto;
  &__guide {
    display: flex;
    &__icon {
      height: 0.95rem;
      padding-top: 0.21rem;
      margin: 0 0.12rem;
      &--src {
        width: 0.43rem;
        height: 0.43rem;
        .bg-image-auto(
          'https://s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/circle-arrow-20220411.png'
        );
      }
    }
  }
  &__dcep {
    background: #f7f8fa;
    border-radius: 0.2rem;
    margin: 0.43rem 0.51rem 0.23rem 0.56rem;
    display: flex;
    align-items: center;
    padding: 0.4rem 0.27rem;
    justify-content: space-between;
    &__logo {
      width: 0.68rem;
      height: 0.68rem;
      .bg-image-auto(
        'https://s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/dcep-logo-20220408.png'
      );
    }
    &__official {
      margin-left: 0.15rem;
      &--title {
        font-family: PingFangSC-Semibold;
        font-size: 0.28rem;
        color: #222222;
        letter-spacing: 0;
        font-weight: 600;
        line-height: 0.4rem;
      }
      &--tip {
        display: flex;
        .official-icon {
          width: 0.25rem;
          height: 0.28rem;
          .bg-image-auto(
            'https://s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/qualification-img-20220408.png'
          );
        }
        .official-text {
          opacity: 0.4;
          font-family: PingFangSC-Regular;
          font-size: 0.2rem;
          color: #000000;
          letter-spacing: 0;
          line-height: 0.32rem;
          font-weight: 400;
          margin-left: 0.04rem;
        }
      }
    }
    &__button {
      position: relative;
      &--hand {
        position: absolute;
        left: 1.34rem;
        top: 0.46rem;
        width: 0.84rem;
        height: 1rem;
        .bg-image-auto(
          'https://s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/click-animate-20220726.gif'
        );
      }
    }
  }
  &__tip {
    font-family: PingFangSC-Regular;
    font-size: 0.22rem;
    color: #000000;
    opacity: 0.4;
    text-align: center;
    font-weight: 400;
    line-height: 0.3rem;
    margin: 0.23rem auto 0.35rem;
  }
}
</style>
